import React, { FunctionComponent, JSX } from 'react';

import classNames from 'classnames';

import { EvSection } from '@evinced-private/ui-common';

import { formatTextToId } from '../../../../helpers/IdFormatterHelper';

import './ChartsSection.scss';

interface IChartsSectionProps {
	sectionTextBlockTitle: string;
	sectionLabel: string;
	/**
	 * skiplinkId to be passed to the section, required for skiplinks
	 */
	skiplinkId: string;
	className?: string;
	children: JSX.Element | JSX.Element[];
}

const ChartsSectionV3: FunctionComponent<IChartsSectionProps> = ({
	sectionTextBlockTitle,
	sectionLabel,
	children,
	className,
	skiplinkId
}: IChartsSectionProps) => {
	const sectionTitleId = formatTextToId(sectionTextBlockTitle);
	const classes: string = classNames('charts-section', { [className]: !!className });

	return (
		<EvSection
			className={classes}
			ariaLabel={sectionLabel}
			ariaLabelledby={sectionTitleId}
			skipLinkId={skiplinkId}
		>
			{children}
		</EvSection>
	);
};

export { ChartsSectionV3 };
